/* eslint-disable no-param-reassign */
import { reactive } from 'vue'
import WStorage from './WStorage'

const defaultProps = {
    name: 'storage',
    key: 'wstorage',
    storage: 'local',
    isSupported: true,
}

export default {
    /**
     * Install vue-wstorage plugin
     *
     * @param {Vue} Vue
     * @param {Object} options
     */
    install: (app, options = {}) => {
        if (typeof process !== 'undefined' && (process.server || process.SERVER_BUILD || (process.env && process.env.VUE_ENV === 'server'))) return

        const { name, key, storage } = options
        const props = {
            ...defaultProps,
            name: name || defaultProps.name,
            key: key || defaultProps.key,
            storage: storage || defaultProps.storage,
        }

        try {
            const test = 'vue-wstorage-test'
            window.localStorage.setItem(test, test)
            window.localStorage.removeItem(test)
        } catch (e) {
            props.isSupported = false
            console.error('Local or Session storage is not supported')
        }

        const wStorageInstance = reactive(new WStorage(props))
        app.config.globalProperties[`$${props.name}`] = wStorageInstance
        app.provide(props.name, wStorageInstance)
    },
    initialize: (props = {}) => new WStorage({ ...defaultProps, ...props }),
}
